module.exports = __webpack_public_path__ + "ainabarcelona.jpg?1fa69819a9774b12340640c5e8c19dac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/ainabarcelona.jpg
// module id = 101
// module chunks = 0